import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SandySpringsHeroSection from "./components/HeroSection";
import SandySpringsStickyNav from "./components/StickyNav";
import SandySpringsProcessingTimeSection from "./components/ProcessingTimeSection";
import SandySpringsServicesSection from "./components/ServicesSection";
import SandySpringsLocalAreaSection from "./components/LocalAreaSection";
import SandySpringsTestimonialsSection from "./components/TestimonialsSection";
import SandySpringsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SandySpringsComparisonSection from "./components/ComparisonSection";
import SandySpringsMistakesSection from "./components/MistakesSection";
import SandySpringsHowItWorksSection from "./components/HowItWorksSection";
import SandySpringsFAQSection, { faqs } from "./components/FAQSection";
import SandySpringsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SandySpringsFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function SandySpringsPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Sandy Springs"
        state="Georgia"
        stateAbbr="GA"
        route="/sandy-springs"
        title="Emergency Passport Sandy Springs, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Sandy Springs, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving metro Atlanta travelers. Get your emergency passport fast!"
        keywords="expedited passport, emergency passport, Sandy Springs passport, same day passport Atlanta, fast passport Georgia"
        geoPlacename="Sandy Springs, Georgia"
        geoPosition="33.9304;-84.3733"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <SandySpringsHeroSection />
      <SandySpringsStickyNav />
      <SandySpringsProcessingTimeSection />
      <SandySpringsLocalAreaSection />
      <SandySpringsServicesSection />
      <SandySpringsTestimonialsSection />
      <SandySpringsAcceptanceFacilitiesSection />
      <SandySpringsComparisonSection />
      <SandySpringsMistakesSection />
      <SandySpringsHowItWorksSection />
      <SandySpringsFAQSection />
      <SandySpringsHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/sandy-springs" state="GA" />
      <SandySpringsFinalCTA />
    </div>
  );
}